import Vue from "vue";
import VueRouter from "vue-router";
import volumes from "../store";
import Login from "../views/Login.vue";
import Home from "../views/Home.vue";
import Entidade from "../components/dashboard/Entidade.vue";
import Perfil from "../components/dashboard/client/Profile.vue";
import jwtDecode from "jwt-decode";
import ResetPwd from "../views/ResetPwd";
import Config from "../components/dashboard/client/Config";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import apiServices from "../../services/apiServices";
import HomeEnterprise from "../views/HomeEnterprise";
import Transactions from "../components/dashboard/enterprise/Transactions";
import Facturas from "../components/dashboard/enterprise/Facturas";
import UnpaidInvoice from "../components/dashboard/enterprise/UnpaidInvoice";
import PaidInvoice from "../components/dashboard/enterprise/PaidInvoice";
import AnalizeInvoice from "../components/dashboard/enterprise/AnalizeInvoice";
import Reports from "../components/dashboard/enterprise/Reports";
import Products from "../components/dashboard/enterprise/Products";
import ProfileEnterprise from "../components/dashboard/enterprise/ProfileEnterprise";
import ConfigEnterprise from "../components/dashboard/enterprise/ConfigEnterprise";
import ProductCategory from "../components/dashboard/enterprise/ProductCategory";
import TransactionsClient from "../components/dashboard/client/TransactionsClient";

Vue.use(VueRouter);

const routes = [
  /**
   * GLOBAL ROUTES
   */
  {
    path: "*",
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName : NotFound */
        "../views/NotFound.vue"
      )
  },
  {
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      title: "Login - Kyami Pay"
    }
  },

  {
    path: "/reset/password",
    name: "reset/password",
    component: ResetPwd,
    meta: {
      title: "Recuperar Palavra Passe - Kyami Pay"
    }
  },

  /**
   * FIRST STATEMENT
   */
  {
    path: "/console",
    name: "/dashboard",
    component: Home,
    beforeEnter: (to, from, next) => {
      const userToken = localStorage.getItem("token");
      const decode = jwtDecode(userToken);
      let startWith = decode.Pub;
      let ref = startWith.substr(0, 6);
      if (volumes.getters.getFullName && ref === volumes.getters.getRefusion) {
        next();
      }
      if (ref === volumes.getters.getRefusion) {
        volumes.dispatch("getClient").then(() => {
          next();
        });
      }
      next(false);
    },
    meta: {
      title: "Console - Kyami Pay",
      requiresAuth: true
    },
    children: [
      {
        path: "/entity",
        name: "entity",
        component: Entidade,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ref = startWith.substr(0, 6);
          if (
            volumes.getters.getProductToDisplay &&
            ref === volumes.getters.getRefusion
          ) {
            next();
          }
          if (ref === volumes.getters.getRefusion) {
            volumes.dispatch("displayAllProduct").then(() => {
              next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      {
        path: "/account/profile",
        name: "perfil",
        component: Perfil,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ref = startWith.substr(0, 6);
          if (ref === volumes.getters.getRefusion) {
            next();
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      // {
      //   path: "/account/wallet",
      //   name: "carteira",
      //   component: Wallet,
      //   beforeEnter: (to, from, next) => {
      //     const userToken = localStorage.getItem("token");
      //     const decode = jwtDecode(userToken);
      //     let startWith = decode.Pub;
      //     let ref = startWith.substr(0, 6);
      //     if (
      //       volumes.getters.getTransactionToStoryWallet &&
      //       volumes.getters.getBalanceClient &&
      //       ref === volumes.getters.getRefusion
      //     ) {
      //       next();
      //     }
      //
      //     if (ref === volumes.getters.getRefusion) {
      //       volumes.dispatch("getTransaction").then(() => {
      //         volumes.dispatch("getBankAccount").then(() => {
      //           next();
      //         });
      //       });
      //     }
      //     next(false);
      //   },
      //   meta: {
      //     title: "Console - Kyami Pay",
      //     requiresAuth: true
      //   }
      // },

      {
        path: "/account/transactions",
        name: "account/transactions",
        component: TransactionsClient,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ref = startWith.substr(0, 6);
          if (
            volumes.getters.getAllCTransactions &&
            ref === volumes.getters.getRefusion
          ) {
            next();
          }
          if (ref === volumes.getters.getRefusion) {
            volumes.dispatch("displayAllCTransaction", decode.CA).then(() => {
              next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },

      {
        path: "/account/config",
        name: "config",
        component: Config,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ref = startWith.substr(0, 6);
          if (ref === volumes.getters.getRefusion) {
            next();
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      }
    ]
  },

  /**
   * SECOND STATEMENT
   */
  {
    path: "/enterprise",
    name: "enterprise",
    component: HomeEnterprise,
    beforeEnter: (to, from, next) => {
      const userToken = localStorage.getItem("token");
      const decode = jwtDecode(userToken);
      let startWith = decode.Pub;
      let ref = startWith.substr(5, 6);
      if (ref === volumes.getters.getRefusionUnunion) {
        volumes.dispatch("getEntity").then(() => {
          volumes.dispatch("displayAllETransaction", decode.CA).then(() => {
            volumes.dispatch("getBalanceReportToView", decode.CA).then(() => {
              volumes.dispatch("chartTransactionEnt", decode.CA).then(() => {
                return next();
              });
            });
            // return next();
          });
          // next();
        });
      }
      next(false);
    },
    meta: {
      title: "Console - Kyami Pay",
      requiresAuth: true
    },
    children: [
      {
        path: "/transactions",
        name: "transactions",
        component: Transactions,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ref = startWith.substr(5, 6);
          if (ref === volumes.getters.getRefusionUnunion) {
            volumes.dispatch("displayAllETransaction", decode.CA).then(() => {
              next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      {
        path: "/invoices",
        name: "invoices",
        component: Facturas,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ref = startWith.substr(5, 6);
          if (ref === volumes.getters.getRefusionUnunion) {
            volumes.dispatch("getInvoiceStatus", decode.CA).then(() => {
              const payload = {
                ca: decode.CA,
                status: "a",
                mutation: "SET_INVOICE_OPEN"
              };
              volumes.dispatch("getInvoiceFullStatus", payload).then(() => {
                return next();
              });
              // next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      {
        path: "/report",
        name: "report",
        component: Reports,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ref = startWith.substr(5, 6);
          if (ref === volumes.getters.getRefusionUnunion) {
            volumes.dispatch("getBalanceReportToView", decode.CA).then(() => {
              volumes.dispatch("chartTransactionEnt", decode.CA).then(() => {
                next();
              });
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      {
        path: "/products/view/:syID",
        name: "products",
        props: true,
        component: Products,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ca = decode.CA;
          let ref = startWith.substr(5, 6);
          if (ref === volumes.getters.getRefusionUnunion) {
            volumes.dispatch("getCategory", ca).then(() => {
              next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      {
        path: "/product/category",
        name: "product.category",
        component: ProductCategory,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ca = decode.CA;
          let ref = startWith.substr(5, 6);

          if (
            volumes.getters.getCategoryInCache &&
            ref === volumes.getters.getRefusionUnunion
          ) {
            next();
          }

          if (ref === volumes.getters.getRefusionUnunion) {
            volumes.dispatch("getCategory", ca).then(() => {
              next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      {
        path: "/e/profile",
        name: "enterprise/profile",
        component: ProfileEnterprise,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ref = startWith.substr(5, 6);

          if (
            volumes.getters.getUserNameEntity &&
            ref === volumes.getters.getRefusionUnunion
          ) {
            next();
          }

          if (ref === volumes.getters.getRefusionUnunion) {
            volumes.dispatch("getEntity").then(() => {
              next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      // {
      //   path: "/w/wallet",
      //   name: "enterprise.wallet",
      //   component: WalletEnterprise,
      //   beforeEnter: (to, from, next) => {
      //     const userToken = localStorage.getItem("token");
      //     const decode = jwtDecode(userToken);
      //     let startWith = decode.Pub;
      //     let ref = startWith.substr(5, 6);
      //     if (ref === volumes.getters.getRefusionUnunion) {
      //       volumes.dispatch("getTransactionE").then(() => {
      //         volumes.dispatch("getBankAccountE").then(() => {
      //           next();
      //         });
      //       });
      //       // volumes.dispatch("getTransaction").then(() => {
      //       //next();
      //       // });
      //     }
      //     next(false);
      //   },
      //   meta: {
      //     title: "Console - Kyami Pay",
      //     requiresAuth: true
      //   }
      // },
      {
        path: "/a/account/config",
        name: "enterprise/config",
        component: ConfigEnterprise,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ref = startWith.substr(5, 6);
          if (ref === volumes.getters.getRefusionUnunion) {
            next();
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      {
        path: "/invoices/unpaid",
        name: "unpaid",
        component: UnpaidInvoice,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ca = decode.CA;
          let ref = startWith.substr(5, 6);
          if (ref === volumes.getters.getRefusionUnunion) {
            const payload = {
              ca: ca,
              status: "a",
              mutation: "SET_INVOICE_OPEN"
            };
            volumes.dispatch("getInvoiceFullStatus", payload).then(() => {
              next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      {
        path: "/invoices/paid",
        name: "paid",
        component: PaidInvoice,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ca = decode.CA;
          let ref = startWith.substr(5, 6);
          if (ref === volumes.getters.getRefusionUnunion) {
            const payload = {
              ca: ca,
              status: "p",
              mutation: "SET_INVOICE_PAID"
            };
            volumes.dispatch("getInvoiceFullStatus", payload).then(() => {
              next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      },
      {
        path: "/invoices/analyze",
        name: "analyze",
        component: AnalizeInvoice,
        beforeEnter: (to, from, next) => {
          const userToken = localStorage.getItem("token");
          const decode = jwtDecode(userToken);
          let startWith = decode.Pub;
          let ca = decode.CA;
          let ref = startWith.substr(5, 6);
          if (ref === volumes.getters.getRefusionUnunion) {
            const payload = {
              ca: ca,
              status: "d",
              mutation: "SET_INVOICE_DISPUTE"
            };
            volumes.dispatch("getInvoiceFullStatus", payload).then(() => {
              next();
            });
          }
          next(false);
        },
        meta: {
          title: "Console - Kyami Pay",
          requiresAuth: true
        }
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const logged = localStorage.getItem("token");
  if (to.matched.some(record => record.meta.requiresAuth) && !logged) {
    next({
      name: "Login"
    });
  } else {
    if (logged) {
      apiServices.customizeHeader(logged);
      apiServices.interceptionRoute();
    }
    NProgress.configure({ showSpinner: false });
    NProgress.start();
    next();
    const decode = jwtDecode(volumes.getters.getUserTokenHeader);
    if (decode.exp > new Date().getTime() / 1000) {
      next();
    } else {
      next({
        name: "Login"
      });
    }
  }
});

router.afterEach(to => {
  Vue.nextTick(() => {
    document.title = to.meta.title || "Kyami Pay";
  });
  NProgress.done();
});
export default router;
